<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$descriptions"
				start
			/>
			<translate>Claim Status Descriptions</translate>
			<v-spacer />
			<v-btn
				v-can="'claimstatusdescription.create'"
				variant="flat"
				color="primary"
				prepend-icon="$plus"
				@click="goToCreate"
			>
				<translate>Add New Description</translate>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col
					v-if="claimStatuses"
					cols="4"
				>
					<v-select
						v-if="claimStatuses"
						v-model="claimStatusFilter"
						variant="outlined"
						:items="claimStatuses"
						item-title="title"
						item-value="value"
						:label="`${$gettext('Claim Status')} ${$gettext('filter')}`"
						clearable
						multiple
						chips
						hide-details
					/>
				</v-col>
				<v-col
					v-if="claimTypes"
					cols="4"
				>
					<v-select
						v-if="claimTypes"
						v-model="claimTypeFilter"
						variant="outlined"
						:items="claimTypes"
						:label="`${$gettext('Claim Type')} ${$gettext('filter')}`"
						clearable
						multiple
						chips
						hide-details
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-data-table
						:items="filterClaimStatusDescriptions"
						:headers="headers"
						:sort-by="[{key: sortBy, order: sortDesc}]"
						:items-per-page="100"
						:items-per-page-options="[100]"
					>
						<template #item.claimstatus="{ item }">
							<a :href="`/bo/claimstatusdescriptions/view?claimstatus_id=${item.claimstatus_id}&claim_type=${item.claim_type}`">
								{{ item.claimstatus.name }}
							</a>
						</template>
						<template #item.claim_type="{ value }">
							{{ claimTypeMap[value] }}
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>

import axios from 'axios';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'ClaimStatusDescriptionOverview',

	data () {
		return {
			items: [],
			sortBy: null,
			sortDesc: true,
			claimStatusFilter: [],
			claimStatuses: [],
			claimTypeFilter: [],
			claimTypes: []
		};
	},

	computed: {
		headers () {
			return [
				{
					title: this.$gettext('Claim Status'),
					sortable: true,
					value: 'claimstatus',
					filterable: true,
				},
				{
					title: this.$gettext('Claim Type'),
					sortable: true,
					value: 'claim_type',
					filterable: true,
				},
			];
		},

		filterClaimStatusDescriptions () {
			return this.items.filter((item) => {
				return (
					(this.claimStatusFilter.length === 0 || this.claimStatusFilter.includes(item.claimstatus.name)) &&
					(this.claimTypeFilter.length === 0 || this.claimTypeFilter.includes(item.claim_type))
				);
			});
		},

		claimTypeMap () {
			return {
				'': this.$gettext('Both'),
				'damage': this.$gettext('Damage'),
				'loss': this.$gettext('Loss')
			};
		}
	},

	mounted () {
		this.getClaimStatusDescriptionData();
	},

	methods: {
		/**
		 * Retrieve claim status descriptions
		 */
		getClaimStatusDescriptionData () {
			axios.get('/api/v0/claimstatusdescriptions/overview')
				.then(({
					data: data
				}) => {
					this.items = data;
					this.formFilters(data);
				}).catch(() => {
					displayError(this.$gettext('Something has gone wrong during during data retrieval'));
				});
		},

		/**
		 * Retrieve the available filter options
		 *
		 * @param {object} data
		 */
		formFilters (data) {
			const claimTypes = [];
			const claimStatuses = [];

			data.forEach((item) => {
				claimTypes.push(item.claim_type);
				claimStatuses.push(item.claimstatus.name);
			});

			[... new Set(claimTypes),].forEach((item) => {
				this.claimTypes.push({
					title: this.claimTypeMap[item],
					value: item
				});
			});
			this.claimStatuses = [... new Set(claimStatuses),];
		},

		/**
		 * Sets location to the claim status description creation route
		 *
		 * @returns {void}
		 */
		goToCreate () {
			window.location.href = '/bo/claimstatusdescriptions/create';
		},
	}
};
</script>
